document.addEventListener('DOMContentLoaded', () => {
    const pageContainer = document.getElementById('create-account-modal');
    if (!pageContainer) return;

    const formElements = {
        form: document.getElementById('createAccountForm'),
        fullname: document.getElementById('signup-form-fullname'),
        email: document.getElementById('signup-form-email'),
        username: document.getElementById('signup-form-username'),
        password: document.getElementById('signup-form-password'),
        passwordIcon: document.getElementById('passwordIcon'),
        createBtn: document.getElementById('create-account-button'),
        errorDisplay: document.getElementById('accountCreateError'),
        successDisplay: document.getElementById('accountCreateSuccess')
    };

    formElements.createBtn.disabled = true;

    let validationObserver;

    const setupLowerCaseInputs = () => {
        if (formElements.username) {
            formElements.username.addEventListener('input', () => {
                formElements.username.value = formElements.username.value.toLowerCase();
            });
        }
        if (formElements.email) {
            formElements.email.addEventListener('input', () => {
                formElements.email.value = formElements.email.value.toLowerCase();
            });
        }
    };


    const validateForm = () => {
        const isFullnameValid = formElements.fullname.classList.contains('is-valid');
        const isEmailValid = formElements.email.classList.contains('is-valid');
        const isUsernameValid = formElements.username.classList.contains('is-valid');
        const isPasswordValid = formElements.password.classList.contains('is-valid');

        formElements.createBtn.disabled = !(isFullnameValid && isEmailValid && isUsernameValid && isPasswordValid);
    };


    const togglePasswordVisibility = () => {
        const isPwdHidden = formElements.password.type === 'password';
        formElements.password.type = isPwdHidden ? 'text' : 'password';
        formElements.passwordIcon.classList.toggle('icon-eye', !isPwdHidden);
        formElements.passwordIcon.classList.toggle('icon-eye-off', isPwdHidden);
    };

    const loadZxcvbn = () => {
        if (!window.zxcvbn && !window.zxcvbnLoading) {
            window.zxcvbnLoading = true;
            const script = document.createElement('script');
            script.src = `${g_devtricker_Settings.siteUrl}/wp-includes/js/zxcvbn.min.js`;
            script.async = true;
            script.onload = () => {
                devtricker_log(null, devtricker_log_level.INFO, "zxcvbn loaded");
            };
            script.onerror = (err) => {
                devtricker_log(err, devtricker_log_level.ERROR, "zxcvbn failed to load");
            };
            document.head.appendChild(script);
        }
    };

    const setupValidationObserver = () => {
        validationObserver = new MutationObserver(mutations => {
            for (let m of mutations) {
                if (m.type === 'attributes' && m.attributeName === 'class') {
                    validateForm();
                    break;
                }
            }
        });
        [
            formElements.fullname,
            formElements.email,
            formElements.username,
            formElements.password
        ].forEach(input => {
            if (input) validationObserver.observe(input, { attributes: true });
        });
    };

    const setupValidationEvents = () => {
        formElements.fullname.addEventListener('input', () => {
            devtricker_dom_set_clearCreateAccountInput(formElements.fullname);
        });
        formElements.fullname.addEventListener('blur', () => {
            devtricker_process_validateFullname(formElements.fullname);
        });

        formElements.email.addEventListener('input', () => {
            devtricker_dom_set_clearCreateAccountInput(formElements.email);
            devtricker_process_validateEmail(formElements.email);
        });
        formElements.email.addEventListener('blur', () => {
            devtricker_process_validateEmail(formElements.email);
        });

        formElements.username.addEventListener('input', () => {
            devtricker_dom_set_clearCreateAccountInput(formElements.username);
            devtricker_process_validateUsername(formElements.username);
        });
        formElements.username.addEventListener('blur', () => {
            devtricker_process_validateUsername(formElements.username);
        });

        formElements.password.addEventListener('input', () => {
            devtricker_process_validatePassword(formElements.password);
        });

        formElements.passwordIcon.addEventListener('click', togglePasswordVisibility);
    };

    const handleAccountCreation = async (e) => {
        e.preventDefault();
        if (formElements.createBtn.disabled) return;

        formElements.createBtn.disabled = true;
        formElements.createBtn.innerHTML = 'Loading...';

        try {
            await devtricker_process_creteAccount(formElements.form);
            formElements.form.reset();
            formElements.createBtn.innerHTML = 'Create Account';
            formElements.createBtn.disabled = true;
            
            [formElements.fullname, formElements.email, formElements.username, formElements.password].forEach(input => {
                input.classList.remove('is-valid', 'is-invalid');
                const errorMsg = input.nextElementSibling;
                if (errorMsg && errorMsg.classList.contains('error-message')) {
                    errorMsg.style.display = 'none';
                }
            });
            
            formElements.password.type = 'password';
            formElements.passwordIcon.classList.add('icon-eye');
            formElements.passwordIcon.classList.remove('icon-eye-off');
            
        } catch (error) {
            formElements.errorDisplay.textContent = error.message || g_devtricker_i18n.account_creation_error_1;
            formElements.errorDisplay.style.display = 'block';
            console.error('Account creation error:', error);
            formElements.createBtn.innerHTML = 'Create Account';
            formElements.createBtn.disabled = false;
        }
    };

    const initializePage = () => {
        setupLowerCaseInputs();
        setupValidationEvents();
        setupValidationObserver();
        loadZxcvbn();
        
        formElements.createBtn.addEventListener('click', handleAccountCreation);
    };

    initializePage();
});